import MarkdownIt from 'markdown-it/lib';

export const mdParser = new MarkdownIt(
  /* Markdown-it options */ {
    html: true,
    linkify: true,
    typographer: true,
    breaks: true,
    quotes: '“”‘’',
  },
);
